(() => {
  if (window.__giestoProductInteractions) return;
  window.__giestoProductInteractions = true;
  const tr = document.documentElement.lang.toLowerCase().startsWith('tr');
  const sprite = document.querySelector('.gap--reference .gap__helpers use')?.getAttribute('href')?.split('#')[0];
  const icon = name => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    const use = document.createElementNS(svg.namespaceURI, 'use');
    svg.setAttribute('aria-hidden', 'true');
    use.setAttribute('href', `${sprite}#${name}`);
    svg.append(use);
    return svg;
  };
  function openSheet(product, trigger) {
    const dialog = product.querySelector(`[data-gaa-sheet="${trigger.dataset.gaaOpen}"]`);
    if (!dialog || dialog.open) return;
    trigger.setAttribute('aria-expanded', 'true');
    dialog.addEventListener('close', () => {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus({ preventScroll: true });
    }, { once: true });
    dialog.showModal();
  }
  function openZoom(product, trigger) {
    const images = [...product.querySelectorAll('[data-gap-zoom] img')];
    const index = images.indexOf(trigger.querySelector('img'));
    const dialog = document.createElement('dialog');
    dialog.className = 'gaa__zoom';
    dialog.setAttribute('aria-label', tr ? 'Ürün görselleri' : 'Product images');
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'gaa__zoom-close';
    close.setAttribute('aria-label', tr ? 'Kapat' : 'Close');
    const label = document.createElement('span');
    label.textContent = tr ? 'Kapat' : 'Close';
    close.append(icon('navigate-remove'), label);
    close.onclick = () => dialog.close();
    const thumbs = document.createElement('div');
    thumbs.className = 'gaa__zoom-thumbs';
    const track = document.createElement('div');
    track.className = 'gaa__zoom-track';
    const select = (index, behavior = 'smooth') => {
      if (matchMedia('(min-width:1025px)').matches) {
        track.scrollTo({ left: index * track.clientWidth, behavior });
        dialog.scrollTo({ top: 0, behavior });
      } else dialog.scrollTo({ top: track.children[index].offsetTop, behavior });
      [...thumbs.children].forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
    };
    images.forEach((image, i) => {
      const large = image.cloneNode();
      large.removeAttribute('srcset');
      large.removeAttribute('sizes');
      // Request the original Shopify image at zoom resolution, not the thumbnail.
      const url = new URL(image.currentSrc || image.src, location.href);
      url.searchParams.set('width', '2400');
      large.src = url.href;
      large.loading = 'eager';
      track.append(large);
      const thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.setAttribute('aria-label', `${tr ? 'Görsel' : 'Image'} ${i + 1}`);
      const small = image.cloneNode();
      small.alt = '';
      thumb.append(small);
      thumb.onclick = () => select(i);
      thumbs.append(thumb);
    });
    dialog.append(close, thumbs, track);
    product.append(dialog);
    dialog.addEventListener('close', () => {
      dialog.remove();
      trigger.focus({ preventScroll: true });
    }, { once: true });
    dialog.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      const current = matchMedia('(min-width:1025px)').matches
        ? Math.round(track.scrollLeft / track.clientWidth)
        : Math.round(dialog.scrollTop / track.children[0].clientHeight);
      select(Math.max(0, Math.min(images.length - 1, current + (event.key === 'ArrowRight' ? 1 : -1))));
    });
    dialog.showModal();
    requestAnimationFrame(() => select(Math.max(0, index), 'instant'));
  }
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    const product = target?.closest('.gap--reference');
    if (!product) return;
    const zoom = target.closest('[data-gap-zoom]');
    if (zoom) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openZoom(product, zoom);
      return;
    }
    const trigger = target.closest('[data-gaa-open]');
    if (trigger) openSheet(product, trigger);
    const color = target.closest('.gaa__native-color');
    if (color && !color.disabled) setTimeout(() => color.closest('dialog')?.close(), 0);
    if (target.closest('[data-gaa-close]')) target.closest('dialog')?.close();
    if (target.matches('dialog.gaa__sheet')) {
      const bounds = target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) target.close();
    }
  }, true);
  function initialize() {
    for (const product of document.querySelectorAll('.gap--reference')) {
      const rail = product.querySelector('[data-gap-thumbs]');
      if (!rail || product.querySelector('.gaa__rail-next')) continue;
      const next = document.createElement('button');
      next.type = 'button';
      next.className = 'gaa__rail-next';
      next.setAttribute('aria-label', tr ? 'Diğer görseller' : 'More images');
      next.append(icon('navigate-arrow-down'));
      const end = () => rail.scrollTop + rail.clientHeight >= rail.scrollHeight - 16;
      next.onclick = () => rail.scrollTo({ top: end() ? 0 : rail.scrollTop + rail.clientHeight, behavior: 'smooth' });
      rail.addEventListener('scroll', () => { next.firstChild.style.transform = end() ? 'rotate(180deg)' : ''; }, { passive: true });
      rail.parentElement.append(next);
    }
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
